import { render } from "./create_main_sections.html?vue&type=template&id=1efa8424&external"
import script from "./create_main_sections.js?vue&type=script&lang=js&external"
export * from "./create_main_sections.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__